module.exports = __webpack_public_path__ + "static/media/pla_roc_bre_cab.be33fdb9.png";